import { c as _c } from "react/compiler-runtime";
import request from '@onefootprint/request';
import type { Organization } from '@onefootprint/request-types/dashboard';
import { useQuery } from '@tanstack/react-query';
import { DASHBOARD_AUTHORIZATION_HEADER } from '@/config/constants';
import useSession from '@/hooks/use-session';
const getAuthRoles = async ({
  authToken
}: {
  authToken: string;
}) => {
  const {
    data
  } = await request<Organization[]>({
    method: 'GET',
    url: '/org/auth/roles',
    headers: {
      [DASHBOARD_AUTHORIZATION_HEADER]: authToken
    }
  });
  return data;
};
const useTenantsOptions = () => {
  const $ = _c(8);
  const {
    dangerouslyCastedData
  } = useSession();
  const authToken = dangerouslyCastedData.auth;
  let t0;
  if ($[0] !== authToken) {
    t0 = ["tenantsOptions", authToken];
    $[0] = authToken;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== dangerouslyCastedData.auth) {
    t1 = () => getAuthRoles({
      authToken: dangerouslyCastedData.auth
    });
    $[2] = dangerouslyCastedData.auth;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = !!authToken;
  let t3;
  if ($[4] !== t0 || $[5] !== t1 || $[6] !== t2) {
    t3 = {
      queryKey: t0,
      queryFn: t1,
      enabled: t2,
      select: _temp2
    };
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return useQuery(t3);
};
export default useTenantsOptions;
function _temp(tenant) {
  return {
    label: tenant.name,
    value: tenant.id
  };
}
function _temp2(res) {
  return res.map(_temp);
}